import React from "react";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  centro: {
    // marginTop: theme.spacing(8),
    // padding: theme.spacing(8),

    paddingTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }  
}));

export const SplashPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.centro}>

      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>

    </div>
  );
};
